import React from "react";

/**
 * Apply this style to every span that renders a ZEREZ ID (unitCode, certificateNumber, certificateCode).
 * Menlo / Consolas / Liberation Mono all include a native slashed zero, making 0 vs O unambiguous.
 * grey700 (#616161) is one step lighter than body text, matching the secondary-text convention used
 * throughout the app so the ID reads as supporting info without clashing.
 */
export const zerezIdFontStyle: React.CSSProperties = {
  fontFamily: "'Menlo', 'Consolas', 'Liberation Mono', 'Courier New', monospace",
  fontVariantNumeric: "slashed-zero tabular-nums",
  fontFeatureSettings: '"zero" 1',
  color: "#616161",
};
